import React from "react";
import { Link } from 'react-router-dom';
import { useShop } from '../context/ShopContext';

function AdoptionShop() {
  const { products } = useShop();
  // Show last 6 products
  const displayProducts = products ? [...products].reverse().slice(0, 6) : [];

  return (
    <section className="adoption-shop-area">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-7 col-lg-9">
            <div className="section-title text-center mb-65">
              <div className="section-icon"><img src="img/icon/pawprint_blue.png" alt="" /></div>
              <h5 className="sub-title">Boutique Kaki</h5>
              <h2 className="title">Nos Nouveautés</h2>
              <p>Découvrez nos derniers articles pour vos compagnons à quatre pattes.</p>
            </div>
          </div>
        </div>
        <div className="row justify-content-center">
          {displayProducts.map((product, index) => (
            <div className={`col-lg-4 col-md-6 ${index >= 3 ? 'd-none d-md-block' : ''}`} key={product.id || product._id}>
              <div className="adoption-shop-item">
                <div className="adoption-shop-thumb">
                  <img
                    src={`${process.env.REACT_APP_API_URL}/${product.img}`}
                    alt={product.name}
                    style={{ width: '100%', height: '350px', objectFit: 'cover' }}
                  />
                  <Link to={`/shop/${product.productId || product.id}`} className="btn">Acheter <img src="img/icon/w_pawprint.png" alt="" /></Link>
                </div>
                <div className="adoption-shop-content">
                  <h4 className="title"><Link to={`/shop/${product.productId || product.id}`}>{product.name}</Link></h4>
                  <div className="adoption-meta">
                    <ul>
                      <li><i className="fas fa-paw" /><a href="#">{product.collection?.name || product.category || 'Produit Kaki'}</a></li>
                      {/* <li><i className="far fa-calendar-alt" /> Naissance : 2021</li> */}
                    </ul>
                  </div>
                  <div className="adoption-rating">
                    <ul>
                      <li className="rating">
                        <i className="fas fa-star" />
                        <i className="fas fa-star" />
                        <i className="fas fa-star" />
                        <i className="fas fa-star" />
                        <i className="fas fa-star" />
                      </li>
                      <li className="price">Prix : <span>{product.price}</span></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          ))}
          {displayProducts.length === 0 && (
            <div className="col-12 text-center">
              <p>Chargement des produits...</p>
            </div>
          )}
        </div>
        <div className="row justify-content-center mt-30">
          <div className="col-12 text-center">
            <Link to="/shop" className="btn">Voir toute la boutique <img src="img/icon/w_pawprint.png" alt="" /></Link>
          </div>
        </div>
      </div>
    </section>

  )
}

export default AdoptionShop;
